import React from "react"
import styled from "styled-components"
import {StaticImage} from "gatsby-plugin-image"
import { Section, SectionImageBkg } from "../Section"
import { ArrowLeftIcon, CallIcon, TollFreeIcon } from "../Icons"
import QuotePopUpButton from "../QuotePopUpButton"
import WhiteLineButton from "../Button/WhiteLineButton"

const Grid = styled.div`
    display:flex;
    flex-wrap:wrap;
    justify-content:space-between;
    align-items: center;
    margin:0 -15px;
    text-align:center;
    @media (min-width:992px) {
        text-align:left;
    }
`
const GridLeft = styled.div`
    position:relative;
    width:100%;
    padding:0 15px 15px;
    @media(min-width:992px){
        padding:0 15px;
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }
    > .sub-title, h2{   
        color:#fff;
        font-weight:500;
        margin-bottom: 5px;
    }
    > .sub-title{
        display:block;
        font-size: 14px;
        line-height: 28px;
        @media (min-width: 576px) {
            font-size: 16px;
            line-height: 30px;
        }
        @media (min-width: 768px) {
            font-size: 18px;
            line-height: 30px;
        }
        @media (min-width: 992px) {
            font-size: 20px;
            line-height: 30px;
        }
        @media (min-width: 1200px) {
            font-size: 24px;
            line-height: 34px;
        }
        @media (min-width: 1600px) {
            font-size: 28px;
            line-height: 38px;
        }
    }
    > h2{
        color:#fff;
        font-weight: 500;
        margin-bottom:0;
        @media (max-width: 575.98px) {
            font-size: 18px;
            line-height: 28px;
        }
    }
`
const GridRight = styled.div`
    position:relative;
    width:100%;
    padding:0 15px;
    @media(min-width:992px){
        flex: 0 0 auto;
        width: auto;
        max-width: 100%;
    }
    .phone-text {
        color: #fff;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        a {
            margin: 0;
            margin-left: 15px;
        }
    }
    .h2{
        margin-bottom:15px;
        display:block;
        color:#fff;
        font-size: 20px;
        line-height: 1.5;

        @media (min-width: 1600px){
            font-size: 30px;
            line-height: 1.5;
        }
        &:hover{
            color:#E9242A;
        }
    }
    .btn{
        &:hover{
            border-color:#fff;
        }
    }

`
const QuoteAction = styled.div`
    + .call{
        margin-top:15px;
    }
`
const CallActon = styled.div`
  display:flex;
  flex-wrap:wrap;
  justify-content: center;
  @media (min-width:992px) {
    justify-content: left;
  }
`
const CallUs = ({ location, thanksURL }) => {
    return (
        <Section ept="70px" epb="70px" xpt="40px" xpb="40px" pt="30px" pb="30px" bgColor="#373636" className="section-call">
            <SectionImageBkg opacity="0.5"><StaticImage src="../../images/callus-bg.jpg" alt="callus-bg" /></SectionImageBkg>
            <div className="container">
                <Grid>
                    <GridLeft>
                        <span className="sub-title">Ready to get started on your building project?</span>
                        <h2 className="h3">Connect With Our Experts Today</h2>
                    </GridLeft>
                    <GridRight>
                        
                        {!location.pathname.includes("/thank-you") && (
                            <QuoteAction  className="quote">
                                <QuotePopUpButton thanksURL={thanksURL} text="Request A Free Quote" iconAfter={<ArrowLeftIcon />} />
                            </QuoteAction>
                        )}
                        <CallActon className="call">
                            <a href="tel:2085721441" aria-label="phone number">
                                <WhiteLineButton icon={<CallIcon />} text="(208) 572-1441" size="md" />
                            </a>
                            <a href="tel:18335442957">
                                <WhiteLineButton icon={<TollFreeIcon />}  text="1-833-544-2957" size="md" />
                            </a>
                        </CallActon>
                    </GridRight>
                </Grid>
                
            </div>
        </Section>
    )
}

export default CallUs
